import React, { useState } from 'react';
import { Accordion, Form, InputGroup, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaUserCheck, FaSignInAlt, FaSignOutAlt, FaSearch, FaInfoCircle } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import asignacionCamasTrabajadoresApi from '../../../services/api/asignacionCamasTrabajadoresApi'; // Importar API
import estacionesImpresionApi from '../../../services/api/estacionesImpresionApi'; // Importar API de estaciones

const CheckinCheckout = () => {
  const [dni, setDni] = useState('');
  const [dniCheckout, setDniCheckout] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [estaciones, setEstaciones] = useState([]);
  const [selectedEstacion, setSelectedEstacion] = useState('');
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

  React.useEffect(() => {
      if (selectedProject?.id) {
          estacionesImpresionApi.getAll(selectedProject.id)
              .then(res => {
                  if (res.data.success) {
                      setEstaciones(res.data.data);
                  }
              })
              .catch(err => console.error("Error al cargar estaciones de impresión", err));
      }
  }, [selectedProject?.id]);

  const handleCheckin = async (e) => {
    e.preventDefault();
    if (loading) return;
    
    if (!dni) {
      toast.warning('Por favor, ingrese un DNI.');
      return;
    }
    
    if (!selectedProject || !selectedProject.id) {
        console.error("Check-in error: No valid project selected", selectedProject);
        toast.error('No se ha seleccionado un proyecto.');
        return;
    }

    if (!selectedEstacion) {
        toast.warning('Debe seleccionar/configurar una estación de impresión');
        return;
    }

    console.log("Initiating check-in for DNI:", dni, "Project ID:", selectedProject.id);
    setLoading(true);
    try {
        const response = await asignacionCamasTrabajadoresApi.checkin(dni, selectedProject.id, selectedEstacion);
        
        if (response.data.success) {
            const data = response.data.data;
            toast.success(`Check-in Exitoso: ${data.trabajador}`);
            toast.info(`Cama Asignada: ${data.cama} (Hab: ${data.habitacion}, Módulo: ${data.modulo})`, {
                autoClose: 8000
            });
            setDni(''); // Limpiar campo
        } else {
            toast.error(response.data.message || 'Error al realizar Check-in');
        }
    } catch (error) {
        console.error("Error en Check-in:", error);
        console.log("Error details:", error.response?.data);
        
        let errorMsg = 'Error de conexión o del servidor';
        
        if (error.response?.data?.detail) {
            errorMsg = error.response.data.detail;
        } else if (error.response?.data?.message) {
            errorMsg = error.response.data.message;
        } else if (typeof error.response?.data === 'string') {
             errorMsg = error.response.data;
        }

        toast.error(errorMsg);
    } finally {
        setTimeout(() => setLoading(false), 2000);
    }
  };

  const handleReprint = async () => {
    if (loading) return;

    if (!dni) {
      toast.warning('Por favor, ingrese un DNI para buscar.');
      return;
    }
    
    if (!selectedProject || !selectedProject.id) {
        toast.error('No se ha seleccionado un proyecto.');
        return;
    }

    if (!selectedEstacion) {
        toast.warning('Debe seleccionar/configurar una estación de impresión');
        return;
    }

    setLoading(true);
    try {
        const response = await asignacionCamasTrabajadoresApi.reprint(dni, selectedProject.id, selectedEstacion);
        
        if (response.data.success) {
            const data = response.data.data;
            toast.info(`Re-impresión enviada para: ${data.trabajador}`);
            setDni(''); 
        } else {
            toast.error(response.data.message || 'Error al realizar Re-impresión');
        }
    } catch (error) {
        console.error("Error en Re-impresión:", error);
        let errorMsg = 'Error de conexión o del servidor';
        if (error.response?.data?.detail) errorMsg = error.response.data.detail;
        else if (error.response?.data?.message) errorMsg = error.response.data.message;
        
        toast.error(errorMsg);
    } finally {
        setTimeout(() => setLoading(false), 2000);
    }
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    
    if (!dniCheckout) {
      toast.warning('Por favor, ingrese un DNI.');
      return;
    }
    
    if (!selectedProject || !selectedProject.id) {
        console.error("Check-out error: No valid project selected", selectedProject);
        toast.error('No se ha seleccionado un proyecto.');
        return;
    }

    console.log("Initiating check-out for DNI:", dniCheckout, "Project ID:", selectedProject.id);
    setLoadingCheckout(true);
    try {
        const response = await asignacionCamasTrabajadoresApi.checkout(dniCheckout, selectedProject.id);
        
        if (response.data.success) {
            const data = response.data.data;
            toast.success(`Check-out Exitoso: ${data.trabajador}`);
            toast.info(`Cama liberada: ${data.cama} (Hab: ${data.habitacion}, Módulo: ${data.modulo})`, {
                autoClose: 8000
            });
            setDniCheckout(''); // Limpiar campo
        } else {
            toast.error(response.data.message || 'Error al realizar Check-out');
        }
    } catch (error) {
        console.error("Error en Check-out:", error);
        console.log("Error details:", error.response?.data);
        
        let errorMsg = 'Error de conexión o del servidor';
        
        if (error.response?.data?.detail) {
            errorMsg = error.response.data.detail;
        } else if (error.response?.data?.message) {
            errorMsg = error.response.data.message;
        } else if (typeof error.response?.data === 'string') {
             errorMsg = error.response.data;
        }

        toast.error(errorMsg);
    } finally {
        setLoadingCheckout(false);
    }
  };

  return (
    <>
      <style>
        {`
          .dh-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          .dh-card-main {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
            padding: 2rem;
          }
          .dh-header-title {
            color: #2c3e50;
            font-weight: 700;
            margin-bottom: 1.5rem;
          }
          /* Accordion Styles */
          .accordion-button {
             background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
             font-weight: 600;
             color: #2c3e50;
             border: none;
             box-shadow: none;
          }
          .accordion-button:not(.collapsed) {
             background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
             color: #0d47a1;
             box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);
          }
          .accordion-button:focus {
             box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
             border-color: #86b7fe;
          }
           .form-label-dh {
            font-weight: 700;
            color: #374151;
            margin-bottom: 0.75rem;
          }
          .form-control-dh {
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
          }
           .form-control-dh:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.15);
          }
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 24px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          .btn-dh-primary:hover {
             background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
             transform: translateY(-2px);
             box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
             color: white;
          }
          .btn-dh-info {
            background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 24px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(52, 152, 219, 0.3);
            transition: all 0.3s ease;
          }
          .btn-dh-info:hover {
             background: linear-gradient(135deg, #2980b9 0%, #3498db 100%);
             transform: translateY(-2px);
             box-shadow: 0 8px 25px rgba(52, 152, 219, 0.4);
             color: white;
          }
        `}
      </style>
      
      <div className="dh-bg">
        <div className="container-fluid py-4">
          <ToastContainer />
          <div className="dh-card-main">
            <h2 className="dh-header-title">
              <FaUserCheck className="me-3 text-primary" />
              Gestión de Check-in / Check-out
            </h2>

            <Accordion defaultActiveKey="0">
              {/* CHECK-IN */}
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <FaSignInAlt className="me-2" /> Registro de Entrada (Check-in)
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row justify-content-center py-3">
                    <div className="col-md-8 col-lg-6">
                      <Form onSubmit={handleCheckin}>
                        <div className="mb-4">
                           <Form.Label className="form-label-dh d-flex align-items-center gap-2">
                               <span>Estación para la impresión <span className="text-danger">*</span></span>
                               <OverlayTrigger
                                 placement="top"
                                 overlay={
                                   <Tooltip id="tooltip-estacion">
                                     Validar la estación de impresión configurada en el menú 'Mantenimientos - Hotelería - Estaciones de Impresión Ticket'
                                   </Tooltip>
                                 }
                               >
                                 <span style={{ cursor: 'pointer', color: '#0d6efd' }}>
                                   <FaInfoCircle />
                                 </span>
                               </OverlayTrigger>
                           </Form.Label>
                           <Form.Select 
                             className="form-control-dh"
                             value={selectedEstacion}
                             onChange={(e) => setSelectedEstacion(e.target.value)}
                           >
                               <option value="">-- Seleccione una estación --</option>
                               {estaciones.map(est => (
                                   <option key={est.id} value={est.codigo}>{est.alias} ({est.codigo})</option>
                               ))}
                           </Form.Select>
                        </div>
                        
                        <Form.Label className="form-label-dh">DNI del Trabajador</Form.Label>
                        <div className="d-flex gap-3 align-items-center">
                           <Form.Control
                                type="text"
                                className="form-control-dh flex-grow-1"
                                placeholder="Ingrese número de DNI"
                                value={dni}
                                onChange={(e) => setDni(e.target.value)}
                                maxLength={20}
                              />
                           <button type="submit" className="btn-dh-primary text-nowrap px-4" disabled={loading}>
                             {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                             {loading ? 'Procesando...' : 'Check-in'}
                           </button>
                           <button type="button" className="btn-dh-info text-nowrap px-4" disabled={loading} onClick={handleReprint}>
                             {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                             {loading ? 'Procesando...' : 'Re-Impresión'}
                           </button>
                         </div>
                      </Form>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* CHECK-OUT */}
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <FaSignOutAlt className="me-2" /> Registro de Salida (Check-out)
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row justify-content-center py-3">
                    <div className="col-md-8 col-lg-6">
                      <Form onSubmit={handleCheckout}>
                         <Form.Label className="form-label-dh">DNI del Trabajador</Form.Label>
                         <div className="d-flex gap-3 align-items-center">
                           <Form.Control
                                type="text"
                                className="form-control-dh flex-grow-1"
                                placeholder="Ingrese número de DNI"
                                value={dniCheckout}
                                onChange={(e) => setDniCheckout(e.target.value)}
                                maxLength={20}
                              />
                           <button type="submit" className="btn-dh-primary text-nowrap px-4" disabled={loadingCheckout}>
                             {loadingCheckout ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                             {loadingCheckout ? 'Procesando...' : 'Check-out'}
                           </button>
                         </div>
                         <Form.Text className="text-muted">
                           El check-out liberará la cama y la marcará como disponible nuevamente.
                         </Form.Text>
                      </Form>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckinCheckout;
